module.exports = __webpack_public_path__ + "static/media/v44.88821e13.mp4";